import React, { Suspense, useEffect, lazy } from 'react';
import { SpinnerElement } from '../spinner';

// Skip loading pannellum with video
const Pannellum = lazy(() => import('pannellum-react/es/elements/Pannellum'));

interface SphereViewerProps {
  fullscreen: boolean;
  id: string;
  src: string;
  preview?: string;
  autoLoad?: boolean;
  modifiers?: string;
  onStart?: () => void;
}

const SphereViewer = ({
  fullscreen,
  id,
  src,
  preview,
  autoLoad,
  modifiers,
  onStart,
}: SphereViewerProps) => {
  const [number] = React.useState(Math.floor(100000000 + Math.random() * 900000000));
  useEffect(() => {
    setTimeout(() => {
      const node = !fullscreen && document.querySelector(`#a-${id}-${number}`);
      if (node) {
        node.classList.add('slide-image');
      }

      if (onStart) {
        const startBtn = document.querySelector('.pnlm-load-button');
        if (startBtn) startBtn.addEventListener('click', onStart);
      }
    }, 100);
  }, []);

  return (
    <div data-am-pannellum={modifiers ? modifiers : ''}>
      <Suspense fallback={<SpinnerElement modifiers="inverted" />}>
        <Pannellum
          id={`a-${id}-${number}`}
          image={src}
          hfov={120}
          autoLoad={autoLoad}
          compass
          width={'100%'}
          preview={preview}
        />
      </Suspense>
    </div>
  );
};

export default SphereViewer;
